module.exports = __webpack_public_path__ + "static/media/back_ico_w.25467379.svg";